import { apiCallStream } from '../../utils/servicesUtils'

const BASE_URL = process.env.REACT_APP_BACKEND_URL

export interface ChatUserContext {
  prompt: string | null
  model: string | null
  brand_guidelines_enabled: boolean
  regional_editing_enabled: boolean
  reference_photos_count: number
  image_url: string | null
  previous_image_url: string | null
  include_previous_image: boolean
}

export interface ToolCall {
  name: string
  params: Record<string, any>
}

export interface ChatMessage {
  role: 'user' | 'assistant'
  content: string
  images?: ChatAttachedImage[]
  toolCall?: ToolCall
}

export interface ChatAttachedImage {
  data: string
  media_type: 'image/png' | 'image/jpeg' | 'image/webp' | 'image/gif'
}

export const apiPostChat = (
  message: string,
  activeTab: string,
  userContext: ChatUserContext,
  conversation: ChatMessage[],
  signal?: AbortSignal,
  attachedImages?: ChatAttachedImage[],
  projectId?: string
): Promise<Response> => {
  const url = `${BASE_URL}/api/v2/chat`
  const body = JSON.stringify({
    message,
    active_tab: activeTab,
    user_context: userContext,
    conversation: conversation.map(({ role, content, images }) => ({
      role,
      content: content,
      ...(images && images.length > 0 ? { images } : {}),
    })),
    ...(attachedImages && attachedImages.length > 0 ? { attached_images: attachedImages } : {}),
    ...(projectId ? { project_id: projectId } : {}),
  })
  return apiCallStream(url, 'POST', body, signal)
}
